import { useRouter } from 'next/router';
import { generateTicketFormName } from '../../utils/forms/formHelpers';

// /tickets/new/{id}
// /tickets/TICKET-{id}
// /tickets/TICKET-{id}/requester
// /tickets/TICKET-{id}/organzation
// /tickets/TICKET-{id}
// /users/USER-{id}
// /users/USER-{id}/organization
// /organizations/ORGANIZATION-{id}

export default function useFormName() {
    const { pathname, query } = useRouter();

    if (query.userId) {
        let formName = `/users/USER-${query.userId}`;
        if (pathname.includes('/organization')) formName = `${formName}/organization`;
        return formName;
    }
    if (query.organizationId) {
        return `/organizations/ORGANIZATION-${query.organizationId}`;
    }

    let formName = generateTicketFormName(pathname, query);

    if (query.ticketKey) {
        // user page visited from ticket-page
        if (pathname.includes('/requester')) formName = `${formName}/requester`;
        // organization page visited from ticket-page
        if (pathname.includes('/organization')) formName = `${formName}/organization`;
    }

    return formName;
}
